import { useCallback, useLayoutEffect, useMemo, useRef, useState } from "react";
import tinycolor from "tinycolor2";
import { useColorPicker } from "../../../../hooks/useColorPicker.js";
import { clamp } from "../../utils.js";
function useHue(args) {
  const defaultSize = {
    width: args.defaultWidth,
    height: 12
  };
  const { initialSize = defaultSize, selfColor, setSelfColor } = args;
  const { width, height } = initialSize;
  const [hueSize, setHueSize] = useState(() => initialSize);
  const { onChange } = useColorPicker();
  const hueRef = useRef(null);
  const huePosition = useMemo(() => {
    const hsl = selfColor.toHsl();
    const x = hsl.h / 360 * hueSize.width;
    return {
      x,
      y: 0
    };
  }, [selfColor, hueSize]);
  const onMoveHue = useCallback(
    ({ x: rawX }) => {
      const x = clamp(rawX, hueSize.width - 1, 1);
      const hsl = selfColor.toHsl();
      const currentHexColor = selfColor.toHexString();
      const percent = x / hueSize.width;
      const newHsl = {
        h: 360 * percent,
        s: hsl.s,
        l: hsl.l
      };
      const newColor = tinycolor(newHsl);
      setSelfColor(newColor);
      if (newColor.toHexString() === currentHexColor || !newColor.isValid()) return;
      onChange(null, newColor.toHexString());
    },
    [selfColor, hueSize, onChange, setSelfColor]
  );
  useLayoutEffect(() => {
    setHueSize(hueRef.current?.getBoundingClientRect() ?? { width: 0, height: 0 });
  }, []);
  const hueRect = hueRef.current?.getBoundingClientRect() ?? { width: 0, height: 0 };
  useLayoutEffect(() => {
    if (hueSize.width === hueRect.width && hueSize.height === hueRect.height) return;
    setHueSize({
      width: hueRect.width,
      height: hueRect.height
    });
  }, [hueRect, hueSize]);
  return useMemo(() => {
    const hueColor = `hsl(${selfColor.toHsl().h}, 100%, 50%)`;
    return {
      onMoveHue,
      ref: hueRef,
      styles: {
        width,
        height
      },
      cursor: {
        backgroundColor: hueColor,
        left: huePosition.x
      }
    };
  }, [selfColor, onMoveHue, huePosition, width, height]);
}
export {
  useHue
};
//# sourceMappingURL=useHue.js.map
